// The analytics data is refreshed on a fixed daily schedule (default 02:00 and
// 14:00 IST). `dataDayKey()` returns the current "period" (which rolls over at each
// boundary) so the app can detect a rollover and refetch. Mirrors the server logic.
const OFFSET_MS = 330 * 60 * 1000; // IST (UTC+5:30), no DST
const HOURS = [2, 14];             // boundary hours (02:00 & 14:00)
const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

function boundaryWalls(wall) {
  const d = new Date(wall);
  const midnight = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  const list = [];
  for (const dayOff of [-DAY_MS, 0, DAY_MS]) {
    for (const h of HOURS) list.push(midnight + dayOff + h * HOUR_MS);
  }
  return list.sort((a, b) => a - b);
}

export function dataDayKey() {
  const wall = Date.now() + OFFSET_MS;
  const walls = boundaryWalls(wall);
  let cur = walls[0];
  for (const b of walls) { if (b <= wall) cur = b; else break; }
  const d = new Date(cur);
  return `${d.getUTCFullYear()}-${d.getUTCMonth() + 1}-${d.getUTCDate()}-${d.getUTCHours()}`;
}
